import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=0a7fc94a&scoped=true"
import script from "./DashCard.vue?vue&type=script&lang=js"
export * from "./DashCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7fc94a",
  null
  
)

export default component.exports